import { useSelector } from 'react-redux';
import { randomGameIdSelector } from '../redux/reducers/app/configuration';
import { useFeature } from '@growthbook/growthbook-react';
import { FEATURES } from '../constants/featureToggling';
import * as ROUTE_TEMPLATES from '../constants/routeTemplates';

export const useRandomGameRoute = () => {
  const randomGameId = useSelector(randomGameIdSelector);
  const isEnabledRandomGame = useFeature(FEATURES.ENABLED_RANDOM_SLOT).on;

  if (isEnabledRandomGame && randomGameId) {
    return ROUTE_TEMPLATES.GAME_DETAIL.replace(':gameId', randomGameId);
  } else {
    return ROUTE_TEMPLATES.GAME_DETAIL.replace(':gameId', null);
  }
};
